var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{ref:"layout",attrs:{"label1":"联系","label2":"我们","navName":"contactus","navData":_vm.navData}},[_c('router-view',{staticClass:"content",on:{"loading":_vm.displayShow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }